module.exports = __webpack_public_path__ + "img/logo.06a39896.png";